module.exports = __webpack_public_path__ + "img/EXV_SD_Nav-Icon_Praemierung.3171523f.svg";